import { ChevronRight } from '@mui/icons-material';

const FullWidthButton = ({
    Icon,
    title,
    subtitle,
    onClick,
    type = 'button',
    iconStyle,
    showChevron = true,
    centerContent = !showChevron,
    containerPadding = '0px',
    contentGap = '8px',
    containerStyle,
    buttonStyle,
    buttonClassName = '',
    iconShellClassName = '',
    textClassName = '',
    trailingText,
    accessibilityLabel,
}) => {
    const hasIcon = !!Icon;

    return (
        <div style={{ width: '100%', padding: containerPadding, ...containerStyle }}>
            <button
                type={type}
                onClick={onClick}
                aria-label={accessibilityLabel}
                className={['fullWidthButton', centerContent ? 'fullWidthButtonCentered' : '', buttonClassName].filter(Boolean).join(' ')}
                style={buttonStyle}
            >
                <div className='fullWidthButtonContent'>
                    <div className='fullWidthButtonMain' style={{ gap: hasIcon ? contentGap : '0px' }}>
                        {hasIcon && (
                            <span className={['fullWidthButtonIconShell', iconShellClassName].filter(Boolean).join(' ')}>
                                <Icon style={iconStyle ?? { fontSize: '20px' }} />
                            </span>
                        )}
                        <span className={['fullWidthButtonText', textClassName].filter(Boolean).join(' ')}>
                            {title}
                            {subtitle && <span className='fullWidthButtonSubtitle'>{subtitle}</span>}
                        </span>
                    </div>
                    {trailingText && (
                        <span className='fullWidthButtonTrailing'>
                            {trailingText}
                        </span>
                    )}
                    {showChevron && (
                        <span className='fullWidthButtonChevronShell'>
                            <ChevronRight className='fullWidthButtonChevron' />
                        </span>
                    )}
                </div>
            </button>
        </div>
    );
};

export default FullWidthButton;
